import InfoIcon from '@mui/icons-material/Info';
import { Stack, type SxProps, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import type { ReactNode } from 'react';

import Text from '../Text';

interface Props {
  id?: string;
  tooltipText?: ReactNode | string;
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  sx?: SxProps;
  children?: ReactNode;
}

export default function Label({
  id,
  tooltipText,
  justifyContent = 'flex-start',
  size = 'sm',
  sx,
  children,
}: Props) {
  return (
    <label htmlFor={id}>
      <Stack
        direction="row"
        sx={[
          {
            gap: 1,
            alignItems: 'center',
            justifyContent: justifyContent,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Text
          component="span"
          size={size}
          weight="medium"
          color="grey"
        >
          {children}
        </Text>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <InfoIcon sx={{ width: 14, height: 14, color: grey[600] }} />
          </Tooltip>
        )}
      </Stack>
    </label>
  );
}
